<template>
  <div class="work-flow">
    <div v-for="item in workFlows" :key="item.id" class="flow-node">
      <div class="lefttop-circle"></div>
      <div class="left-line"></div>
      <div class="flow-level">
        <div class="flow-level-line">
          <span style="width: 50" class="flow-status">
            {{ item.handleStatusStr }}
          </span>
          <span style="width: 140" ellipsis=" tooltip: item.assignTimeStr " class="flow-assignTime">
            {{ item.handleTimeStr }}
          </span>
        </div>
        <div class="flow-level-line">
          <span class="flow-des">{{ item.flowDesc }}</span>
        </div>
        <div class="flow-level-line">
          <span class="flow-des">{{ item.description ? item.description : '暂无' }}</span>
        </div>
        <div class="flow-level-line">
          <div v-for="(file, index) in item.fileList" :key="index">
            <img
              v-if="file.fileType == 'image'"
              class="flow-item"
              :src="file.filePath"
              style="maxwidth: 100px; maxheight: 100px"
            />
            <a v-else style="margin: 0 20px" :href="file.filePath">
              {{ file.fileName || '未命名' }}
            </a>
          </div>
        </div>
        <div
          v-for="(eva, index) in item.evaluations"
          :key="index"
          class="flow-level-line-evalution"
        >
          <div style="display: block">
            <div>
              <span class="flow-text-item small-width" style="color: #ffab48">
                {{ eva.handleTypeStr }}
              </span>
              <span class="flow-text-item mid-width">{{ eva.position }}</span>
              <span class="flow-text-item mid-width">{{ eva.handleUser }}</span>
              <span class="flow-text-item">{{ eva.handleTimeStr }}</span>
            </div>
            <p>
              <span class="flow-text-item">内容：</span>
              <span class="flow-text-item large-width">{{
                eva.description ? eva.description : '暂无'
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <div v-for="c in item.childList" :key="c.id" class="flow-level">
        <div class="flow-level-line">
          <span class="flow-status" style="width: 50">
            {{ c.handleStatusStr }}
          </span>
          <!-- <span class="flow-position" style="width: 100" ellipsis=" tooltip: item.position ">
            {{ c.position }}
          </span>
          <span class="flow-handleUser" style="width: 100" ellipsis=" tooltip: item.handleUser ">
            {{ c.handleUser }}
          </span> -->
          <span class="flow-assignTime" style="width: 140" ellipsis=" tooltip: item.assignTimeStr ">
            {{ c.handleTimeStr }}
          </span>
        </div>
        <div class="flow-level-line">
          <span class="flow-des">{{ c.flowDesc }}</span>
        </div>
        <div class="flow-level-line">
          <span class="flow-des">{{ c.description ? c.description : '暂无' }}</span>
        </div>
        <div class="flow-level-line">
          <div v-for="j in c.fileList" :key="j.filePath">
            <img
              v-if="j.fileType == 'image'"
              :src="j.filePath"
              style="maxwidth: 100px; maxheight: 100px"
            />
            <a v-else style="margin: '0 20px'" :href="j.filePath">
              {{ j.fileName || '未命名' }}
            </a>
          </div>
        </div>
        <div v-for="(eva, index) in c.evaluations" :key="index" class="flow-level-line-evalution">
          <div class="flow-level-line-evalution" style="display: block">
            <div>
              <span class="flow-text-item small-width" style="color: #ffab48">
                {{ eva.handleTypeStr }}
              </span>
              <span class="flow-text-item mid-width">{{ eva.position }}</span>
              <span class="flow-text-item mid-width">{{ eva.handleUser }}</span>
              <span class="flow-text-item">{{ eva.handleTimeStr }}</span>
            </div>
            <p>
              <span class="flow-text-item">内容：</span>
              <span class="flow-text-item large-width">{{
                eva.description ? eva.description : '暂无'
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      commentParams: {
        workflowId: '',
        content: '',
      },
      workFlows: [],
    }
  },
  methods: {
    setWorkFlow(data) {
      this.workFlows = data || []
    },
  },
}
</script>

<style lang="scss" scoped>
.flow-node {
  position: relative;
  margin: 0 20px;
  padding: 0 0 10px 0;
}
.flow-node:not(:last-child) {
  border-left: 1px solid #b0bdcd;
}
.flow-level {
  position: relative;
  padding: 1rem 0;
  top: -15px;
  left: 77px;
  width: 40rem;
  margin: 10px 0;
  padding: 10px 0 0 10px;
  background: rgba(191, 222, 255, 0.1);
  .flow-level-line {
    padding: 1rem 0 0 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    img {
      width: 390px;
    }
    .flow-item {
      max-width: 100px;
      max-height: 100px;
      margin: 0 10px;
    }
  }
  .flow-level-line-evalution {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    min-height: 40px;
    padding: 0 60px;
    .flow-text-item {
      margin: 0 4px;
      font-size: 12px;
    }
    .small-width {
      min-width: 40px;
    }
    .mid-width {
      min-width: 60px;
    }
    .large-width {
      min-width: 100px;
      max-width: 200px;
    }
  }
  .flow-des {
    padding: 10px 10px 0 50px;
    color: #fff;
    font-size: 1.2rem;
  }
  .flow-status {
    color: #ffab48;
    font-size: 1.4rem;
    flex: 0 0 50px;
  }
  .flow-handleUser {
    color: #fff;
    flex: 0 0 60px;
  }
  .flow-assignTime {
    color: #b0bdcd;
  }
  .flow-position {
    color: #fff;
    max-width: 130px;
  }
}
.left-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 77px;
  height: 0px;
  border: 1px solid #b0bdcd;
}
.lefttop-circle {
  position: absolute;
  top: -8px;
  left: -8px;
  z-index: 10;
  width: 16px;
  height: 16px;
  background-color: #007bff;
  border-radius: 8px;
}
</style>
